/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { I18nService } from '@dm/core';
import { type Observable } from 'rxjs';

import { HostsService } from '../../../../../../service/block-service/hosts/hosts.service';
import { InfigoService } from '../../../infigo.service';
import { RefreshComponent } from '../../RefreshComponent';

@Component({
    selector: 'app-host-group-base-info',
    templateUrl: './host-group-base-info.component.html',
})
export class HostGroupBaseInfoComponent extends RefreshComponent {
    @Input() item;
    loading = true;
    detail: any = {};
    baseInfo;
    capacityPercentData = 0;
    usageValue = this.hostsService.usageValue;

    constructor(
        public infigoService: InfigoService,
        public hostsService: HostsService,
        public i18n: I18nService,
        public changeDetectorRef: ChangeDetectorRef,
    ) {
        super();
        const I18N = i18n.get;
        this.baseInfo = [
            {
                title: I18N('host.hostGroup_term_hostsNum_lab'),
                key: 'hostNumbe',
            },
            {
                title: I18N('common.description_column'),
                key: 'DESCRIPTION',
                isLongString: true,
            },
        ];
    }

    requestInfo(): Observable<any> {
        return this.infigoService.getHostGroup(this.item.actionParams);
    }

    handleRequest(value: any): void {
        this.detail = value.data;
        this.loading = false;
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }
}
